/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
// 环境的切换
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = '/api'
} else if (process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = ''
} else if (process.env.NODE_ENV == 'production') {
  // axios.defaults.baseURL = 'http://172.16.8.99:8001/'
  // axios.defaults.baseURL = 'http://58.58.58.118:8081/'
  axios.defaults.baseURL = 'http://222.173.143.41:8081/'
}
// console.log(axios.defaults.baseURL);
// 请求超时时间
axios.defaults.timeout = 30000
//get请求头
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8'

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// const service = axios.create({
//     // axios中请求配置有baseURL选项，表示请求URL公共部分
//     baseURL: process.env.VUE_APP_BASE_API,
//     // 超时
//     timeout: 10000
// })

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断\
    return config
  },
  error => {
    return Promise.error(error)
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          // router.replace({
          //     path: '/login',
          //     query: { redirect: router.currentRoute.fullPath }
          // });
          break
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:

          // 清除token
          // localStorage.removeItem('token');
          // store.commit('loginSuccess', null);
          // // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          // setTimeout(() => {
          //     router.replace({
          //         path: '/login',
          //         query: {
          //             redirect: router.currentRoute.fullPath
          //         }
          //     });
          // }, 1000);
          break
        // 404请求不存在
        case 404:
          break
        case 500:

          // var obj = {
          //     phone: util.getUser().phone,
          //     password: util.getUserPassword()
          // }
          // signIn(obj).then(res => {
          //     if (res.data.code == 200) {
          //         util.setToken(res.data.token)
          //     }
          // })
          // var token = util.getToken();
          // store.commit("setToken", token);
          // // var path = store.state.path.replace("/")
          // router.push({
          //     name: "main",
          //     params: {
          //         t: new Date()
          //     }
          // })
          break
        case 501:

        // 其他错误，直接抛出错误提示
        default:
        // error.response.data.message
      }
      return Promise.reject(error.response)
    }
  }
)
export default axios



// WEBPACK FOOTER //
// ./src/request/http.js